import { useCallback, useEffect } from "preact/hooks";

/**
 * Restores all values from localStorage
 * @param {*} signal Must be a DeepSignal
 */
export function useDeepSignalFromLocalStorage(signal) {
  useEffect(() => {
    Object.keys(signal).forEach((key) => {
      signal[key] = localStorage.getItem(key) ?? signal[key];
    });
  });
}

export function useLocalDeepStorageKeyValue(deepSignal) {
  return useCallback(
    (key, value) => {
      deepSignal[key] = value;
      localStorage.setItem(key, value);
    },
    [deepSignal],
  );
}

/**
 * Takes an event and deepSignal and sets the value of the event target to the deepSignal and localStorage using the event target name as the key
 * @param deepSignal
 */
export function useSignalWithLocalStorage(deepSignal) {
  return useCallback(
    (e) => {
      deepSignal[e.target.name] = e.target.value;
      localStorage.setItem(e.target.name, e.target.value);
    },
    [deepSignal],
  );
}
